import React from "react";
import { hr } from "date-fns/locale";
import { format, isAfter } from "date-fns";

function JournalTimeline({ work }) {
  return (
    <div className="timeline">
      {Object.keys(work)
        .sort()
        .reverse()
        .map((year) => {
          return (
            <div key={`y${year}`}>
              {work[year]
                .sort((a, b) => (isAfter(new Date(a.date), new Date(b.date)) ? -1 : 1))
                .map((entry, index) => {
                  return (
                    <div key={`entry${index}`} className="timeline-item">
                      <div className={`timeline-marker has-background-${entry.color}`} />
                      <div className="timeline-content">
                        <p className="">
                          {format(new Date(entry.date), "do MMMM, HH:mm", { locale: hr })}
                        </p>
                        <p>{entry.statusText}</p>
                      </div>
                    </div>
                  );
                })}
                <header className="timeline-header">
                <span className="tag is-warning">
                  <strong>{year}</strong>
                </span>
              </header>
            </div>
          );
        })}
    </div>
  );
}

export default JournalTimeline;
